// THEWOOMAIN script
const THEWOOMAIN = (() => {

    const productSwiper = {
        target: '.main-product__swiper',
        item: '.main-product__item',
        init: function (options) {
            const target = document.querySelector(this.target);
            const items = document.querySelectorAll(this.item);

            items.length > 3 ? this.swiperLoad(options) : this.copyItem(items, options)
        },
        copyItem: function(items, options) {
            const swiper = document.querySelector(`${this.target} .swiper-wrapper`);

            const htmlString = Array.from(items).map(e => e.outerHTML).join('');
            swiper.insertAdjacentHTML("beforeend", htmlString);

            this.swiperLoad(options);
        },
        swiperLoad: function(options) {
            const mainProduct = new Swiper('.main-product__swiper', options);
        },
    };

    return {
        swiperInit: (options) => {
            productSwiper.init(options);
        }
    };
})();
// 
// main-kv__swiper Swiper 초기화
let mainKvSwiper;

function initMainKvSwiper() {
    const target = document.querySelector('.main-kv__swiper-wrap');
    if (!target) return;

    // const slideCount = target.querySelectorAll('.swiper-slide').length;

    if (mainKvSwiper && !mainKvSwiper.destroyed) {
        mainKvSwiper.destroy(true, true);
    }

    mainKvSwiper = new Swiper('.main-kv__swiper-wrap', {
        slidesPerView: 1,
        loop: true,
        speed: 500,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.main-kv__button-next',
            prevEl: '.main-kv__button-prev',
        },
        pagination: {
            el: '.main-kv__control-wrap .main-kv__pagination',
            clickable: true,
            type: 'bullets',
        },
        allowTouchMove: true,
        observer: true,
        on: {
            paginationRender(swiper) {
              const bullets = swiper.pagination.bullets;
          
              bullets.forEach((bullet, index) => {
                bullet.addEventListener('click', () => {
                  swiper.slideToLoop(index);
                  swiper.autoplay.start();
                });
              });
            }
          }
    });

    const playBtn = document.querySelector('.main-kv__swiper-play-btn');
    const pauseBtn = document.querySelector('.main-kv__swiper-pause-btn');
    const controlButton = document.querySelector('.main-kv__control-button');
    function updatePlayPauseUI() {
        playBtn.addEventListener('click', function() {
            if (mainKvSwiper && controlButton.classList.contains('active')) {
                mainKvSwiper.autoplay.start();
                controlButton.classList.remove('active');
            }
        });
        pauseBtn.addEventListener('click', function() {
            if (mainKvSwiper && !controlButton.classList.contains('active')) {
                mainKvSwiper.autoplay.stop();
                controlButton.classList.add('active');
            }
        });
    }
    updatePlayPauseUI();
}


document.addEventListener("DOMContentLoaded", function () {
    // swiper setting
    THEWOOMAIN.swiperInit({
        loop: true,
        slidesPerView: 1,
        centeredSlides: false,
        speed: 500,
        navigation: {
            prevEl: '.swiper-navi--prev',
            nextEl: '.swiper-navi--next',
        },
        breakpoints: {
            751: {
                centeredSlides: true,
                slidesPerView: 2,
            }
        }
    });

    // ===============================
    // Main Page Swipers
    // ===============================
    let mainPageSwiper;

    function initMainPageSwiper() {
        if (mainPageSwiper) {
            mainPageSwiper.destroy(true, true);
        }

        mainPageSwiper = new Swiper('.main-page-swiper', {
            slidesPerView: 1,           // 한 번에 1개 슬라이드
            spaceBetween: 0,            // 슬라이드 간 간격 제거
            loop: false,                // 루프 제거
            watchOverflow: false,       // 슬라이드 숨김 방지
            watchSlidesProgress: false, // 슬라이드 진행 감시 비활성화
            observer: false,            // DOM 변화 감시 비활성화
            observeParents: false,      // 부모 요소 변화 감시 비활성화
            updateOnWindowResize: true, // 윈도우 리사이즈 시 업데이트 활성화
            navigation: {
                nextEl: '.main-button-next',
                prevEl: '.main-button-prev',
            },
            speed: 500,
            grabCursor: true,
            touchRatio: 1,              // 드래그/스와이프 허용
        });
    }


//     // 최초 실행
    initMainPageSwiper();
    initMainKvSwiper();


    // 리사이즈 시 Swiper 재초기화
    let mainPageSwiperResizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(mainPageSwiperResizeTimer);
        mainPageSwiperResizeTimer = setTimeout(function() {
            initMainPageSwiper();
            initMainKvSwiper();
        // main-kv__control-button에서 active 클래스 제거
        document.querySelectorAll('.main-kv__control-button.active').forEach(function(el) {
            el.classList.remove('active');
        });
        }, 200);
    });
    

    // Parallax
    let isMobileKv = window.matchMedia('(max-width: 750px)').matches;
    const mainKv = isMobileKv
        ? new setParallax('.main-kv', '.main-kv__video', '0', '35%', 'bottom center', 'bottom top')
        : new setParallax('.main-kv', '.main-kv__video', '0', '35%', 'bottom center', 'bottom top');
    const mainHighlight = new setParallax('.main-highlight', '.main-highlight__object');
    const mainEssence = new setParallax('.main-essence', '.main-essence__object');
});


